export default function NTFinanciamentoSection() {
  return (
    <section className="bg-white py-10 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-10">
          <div className="flex flex-col items-center gap-5">
            <p className="font-rajdhani font-bold text-[#1B1F5E] text-lg uppercase tracking-wide">
              Financiamentos:
            </p>
            <div className="flex items-center justify-center">
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8k323fcU1P8EZs51jw5pZGoECMlFn3-HB9A&s"
                alt="BNDES - Banco Nacional de Desenvolvimento Econômico e Social"
                className="h-14 w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
